import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllOrders } from '../../redux/Slices/OrderSlice'
import notify from "./../UseNotification"

const UseAllOrders = () => {
    const dispatch = useDispatch()
    const limit = 3
    const { allorders } = useSelector(state => state.OrderReducer)
    const [loading, setLoading] = useState(true)
    const [SearchLoading, setSearchLoading] = useState(true)
    const [PageLoading, setPageLoading] = useState(true)
    const [orderNumber, setOrderNumber] = useState()
    const [searchInputValue, setSearchInputValue] = useState("")
    const [dataCards, setDataCards] = useState([])
    const [paginate, setpaginate] = useState()

    // handle  get all orders
    const HandleGetAllOrders = async () => {
        setLoading(true)
        await dispatch(getAllOrders(`limit=${limit}&page="1"`))
        setLoading(false)
    }

    // handle on cahnge search input value
    const handleChangeSearchInput = (e) => {
        setSearchInputValue(e.target.value)
    }

    // handle on search orders input
    const handleOrdersSearch = async () => {
        setSearchLoading(true)
        await dispatch(getAllOrders(`id=${searchInputValue}&limit=${limit}`))
        setSearchLoading(false)
    }


    // handle press function for pagination
    const onPress = async (page) => {
        setPageLoading(true)
        await dispatch(getAllOrders(`limit=${limit}&page=${page}`))
        setPageLoading(false)
    }


    // run dispatch search 
    useEffect(() => {
        if (searchInputValue === "") {
            HandleGetAllOrders()
        } else {
            handleOrdersSearch()
        }
    }, [searchInputValue])



    // run get all orders function at the first time oage render
    useEffect(() => {
        HandleGetAllOrders()
    }, [])

    // handle response after get all orders
    useEffect(() => {
        if (loading === false) {
            if (allorders && allorders.status === 200) {
                setOrderNumber(allorders.data.results)
                setDataCards(allorders.data.data)
                setpaginate(allorders.data.paginationResult)
            } else {
                notify("check your internet connection", "error")
            }
        }
    }, [loading])

    // handle response after get all orders
    useEffect(() => {
        if (PageLoading === false) {
            if (allorders && allorders.status === 200) {
                setOrderNumber(allorders.data.results)
                setDataCards(allorders.data.data)
                setpaginate(allorders.data.paginationResult)
            } else {
                notify("check your internet connection", "error")
            }
        }
    }, [PageLoading])

    // handle response after dispatch search input
    useEffect(() => {
        if (SearchLoading === false) {
            if (allorders && allorders.data) {
                setDataCards(allorders.data.data)
                setpaginate(allorders.data.paginationResult)
            } else {
                notify("check your internet connection", "error")
            }
        }
    }, [SearchLoading])


    return [orderNumber, dataCards, paginate, onPress, handleChangeSearchInput, searchInputValue, loading]
}

export default UseAllOrders
